"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = __importDefault(require("lodash/debounce"));
/**
 * Automatic handling of window resizes for ListView instances
 */
var ResizableListView = /** @class */ (function () {
    function ResizableListView(listView) {
        this.listView = listView;
        this.resizeHandler = debounce_1.default(this.update.bind(this), 200);
    }
    /**
     * renders list view and appends to given html element
     * @param {HTMLElement} root Dom element where list view will be rendered
     */
    ResizableListView.prototype.render = function (root) {
        this.root = root;
        var size = root.getBoundingClientRect();
        window.addEventListener('resize', this.resizeHandler);
        this.rendered = this.listView.render(size);
        root.appendChild(this.rendered);
    };
    /**
     * cleans up events and executes list destroy methods
     */
    ResizableListView.prototype.destroy = function () {
        window.removeEventListener('resize', this.resizeHandler);
        this.listView.destroy();
        if (this.rendered) {
            this.root.removeChild(this.rendered);
            this.rendered = null;
        }
    };
    /**
     * callback method for resize event listener
     */
    ResizableListView.prototype.update = function () {
        var size = this.root.getBoundingClientRect();
        if (size.width && size.height) {
            if (this.listView) {
                this.listView.update(function (handlers) { return handlers.updateSize(size); });
            }
            else {
                this.render(this.root);
            }
        }
    };
    return ResizableListView;
}());
exports.ResizableListView = ResizableListView;
